var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('app-header'),_vm._v(" "),_c('main',[_c('nuxt')],1),_vm._v(" "),_c('app-footer'),_vm._v(" "),_c('join-modal'),_vm._v(" "),_c('login-modal'),_vm._v(" "),_c('sign-up-modal'),_vm._v(" "),_c('reset-phone-modal'),_vm._v(" "),_c('client-only',[_c('campus-chooser-modal')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }